import * as React from 'react';

import type {Status} from 'nutshell-graphql-types';

import {getNamedFeature} from './consts';
import {PrimaryConfigureCtaButton} from './primary-configure-cta-button';
import type {PageType} from './types';

import styles from './analytics-status.module.css';

type Props = {
    pageType: PageType;
    status: Status;
    onOpenEmbedAnalyticsModal: () => void;
    onClosePopover: () => void;
};

export function TrackingSnippetNotConfiguredBody(props: Props) {
    return (
        <>
            <div className={styles.text}>
                {props.pageType === 'sources' ? (
                    <div>
                        Embed a small snippet of code on your website and channels and sources will
                        be automatically added to leads that come in through your website or try
                        using our WordPress plugin to get started.
                    </div>
                ) : (
                    <div>
                        Embed a small snippet of code on your website to use{' '}
                        {getNamedFeature(props.pageType)} or try using our WordPress plugin to get
                        started.
                    </div>
                )}
            </div>
            <PrimaryConfigureCtaButton
                pageType={props.pageType}
                status={props.status}
                onClosePopover={props.onClosePopover}
                onOpenEmbedAnalyticsModal={props.onOpenEmbedAnalyticsModal}
            />
        </>
    );
}
